export const formatFechaEntrega = (fechaEntrega) => {
	if (!fechaEntrega) {
		return '-';
	}

	const fechaTexto = String(fechaEntrega).split('T')[0];
	const match = fechaTexto.match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (match) {
		return `${match[3]}/${match[2]}/${match[1].slice(-2)}`;
	}

	const fecha = new Date(fechaEntrega);
	if (!Number.isNaN(fecha.getTime())) {
		const dia = String(fecha.getDate()).padStart(2, '0');
		const mes = String(fecha.getMonth() + 1).padStart(2, '0');
		const anio = String(fecha.getFullYear()).slice(-2);
		return `${dia}/${mes}/${anio}`;
	}

	return '-';
};
